export const setGlobalState = (key: string, value: any) => {
  !window.globalState && (window.globalState = {});
  window.globalState[key] = value;
};

export const getGlobalState = (key: string) => window.globalState?.[key];
